import React from "react";
import { useParams } from "react-router-dom";

import LocationBlockedPage from "components/pages/BlockLocation/LocationBlocked";

const LocationBlocked = () => {
  const { id } = useParams();

  return <LocationBlockedPage id={id} />;
};

export default LocationBlocked;
